<template>
    <div id="editor-md">
        <textarea ></textarea>
    </div>
</template>

<script>
import $script from 'scriptjs';
import $ from "jquery";

    export default {
        name: 'Editor',
		props: ["emdData"],
        data() {
            return {
                instance: null,
            };
        },
        mounted() {
        	// async loading js dependencies
      		// editormd depdend on jquery
	        $script([
		        `${this.emdData.editorPath}js/jquery-3.2.1.min.js`,
		    ], () => {
		        $script(`${this.emdData.editorPath}editormd.min-edited.js`, () => {
		          this.initEditor();
		        });
		    });
        },
        methods: {
			getPreviewedHTML: function () {
				return this.instance.getPreviewedHTML()
			},
			getMarkdown: function () {
				return this.instance.getMarkdown()
			},
			setMarkdown: function (markdown) {
				return this.instance.setMarkdown(markdown)
			},
            initEditor() {
            	//加载css
				let cssPath = this.emdData.editorPath + "css/editormd.css";              
				$('head').append( $('<link rel="stylesheet" type="text/css" />').attr('href', cssPath) );
				this.$nextTick((editorMD = window.editormd) => {
					if (editorMD) {
						// Vue 异步执行 DOM 更新，template 里面的 script 标签异步创建
						// 所以，只能在 nextTick 里面初始化 editor.md
						this.instance = editorMD('editor-md', this.emdData.editorConfig);
					}
				});				
			},
        },
    };
	/*
	用法说明
	<editormd  ref="editormdRef" :emdData="emdData" ></editormd>
	data () {
            return {             
                emdData: {
                    editorPath: '/editormd/',
                    editorConfig: {
                            path: '/editormd/lib/',   // Autoload modules mode, codemirror, marked... dependents libs path
                            width            : "100%",
                            height           : 640,
                            imageUpload      : true,
                            imageUploadURL   : URL_img.img.upload,
                            toolbarAutoFixed : false,
                            readOnly         : false,
                            onload           : function() {},       
                    },			
                },
			}
	}
	*/
</script>